import { render } from "./FragranceTable.vue?vue&type=template&id=41e616da&scoped=true"
import script from "./FragranceTable.vue?vue&type=script&lang=js"
export * from "./FragranceTable.vue?vue&type=script&lang=js"

import "./FragranceTable.vue?vue&type=style&index=0&id=41e616da&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41e616da"]])

export default __exports__